import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c463f852")

_pushScopeId("data-v-c463f852")
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","min-height":"100vh"} }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MainHeader = _resolveComponent("MainHeader")
  const _component_MainFooter = _resolveComponent("MainFooter")
  const _component_FeedBack = _resolveComponent("FeedBack")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_component_MainFooter),
    _createVNode(_component_FeedBack)
  ], 64 /* STABLE_FRAGMENT */))
})